import { render, staticRenderFns } from "./i2Divider.vue?vue&type=template&id=23600f10&scoped=true&"
import script from "./i2Divider.vue?vue&type=script&lang=js&"
export * from "./i2Divider.vue?vue&type=script&lang=js&"
import style0 from "./i2Divider.vue?vue&type=style&index=0&id=23600f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23600f10",
  null
  
)

export default component.exports